export enum Sex {
  Male = 0,
  Female = 1,
}
